import React, {Component} from 'react'
import {withRouter} from "react-router"
import ReactHtmlParser from 'react-html-parser';

export class Instructions extends Component {
    styles = {
        container: {
            borderStyle: 'solid',
            borderWidth: '1px',
            padding: '0.1in 0.2in',
            borderRadius: '20px',
            borderColor: '#006595',
        }
    }


    render() {
        const {instructions} = this.props.instructions
        return (
            <div className="no-break-print instructions"
                 style={this.styles.container}>{ReactHtmlParser(instructions)}</div>
        )
    }
}

export default withRouter(Instructions)